<ami-dialog-message [setting]="message"></ami-dialog-message>

<pg-regulated-product-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-regulated-product-create>

<pg-regulated-product-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-regulated-product-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
